import * as React from 'react';
const Dashboard = (props) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#clip0_4421_20209)"
    >
      <path d="M6.5.5h-6v8h6v-8ZM6.5 11.5h-6v4h6v-4ZM15.5.5h-6v5h6v-5ZM15.5 8.5h-6v7h6v-7Z" />
    </g>
    <defs>
      <clipPath id="clip0_4421_20209">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Dashboard;